// removed by extract-text-webpack-plugin
module.exports = {"headTitle":"src-templates-landing-components-header----header-module---headTitle---319yp"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/landing/components/header/header.module.pcss
// module id = 308
// module chunks = 104033720589488